import { Box, Button, Typography } from '@mui/material'
import { useCallback } from 'react'

import { adminInterface } from '../../systems/admin-interface'

export default adminInterface.createNotAuthorizedAdminPage(() => {
  const redirectToLoginPage = useCallback(() => {
    const returnUrl = window.location.href
    location.href = `${phoenix.runtimeConfig.SERVER_URL}/deployments/${phoenix.runtimeConfig.DEPLOYMENT_ID}/auth?returnUrl=${encodeURIComponent(returnUrl)}`
  }, [])

  return (
    <>
      <Box
        component="div"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          gap: 4,
        }}
      >
        <Typography variant="h4">Configurator Admin Panel</Typography>
        <Typography variant="body1">This is a private area. Please log in to continue.</Typography>

        <Button variant="contained" onClick={redirectToLoginPage}>
          Log In
        </Button>
      </Box>

      <Box
        component="div"
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 1000,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Looking for the configurator itself?{' '}
          <a href="/" style={{ color: 'inherit', textDecoration: 'underline' }}>
            Check here!
          </a>
        </Typography>
      </Box>
    </>
  )
})
